__webpack_require__.p = "/directory/assets/";